module.exports = __webpack_public_path__ + "img/cell-wifi.0655e101.svg";